import type { ReactNode } from 'react'

interface SlugSuggestionsProps {
  suggestions: string[]
  onSelect: (slug: string) => void
}

export const SlugSuggestions = ({ suggestions, onSelect }: SlugSuggestionsProps): ReactNode => (
  <div className="slug-suggestions mt-2 space-y-1.5">
    <p className="text-xs text-muted-foreground">Try one of these instead:</p>
    <div className="flex flex-wrap gap-1.5">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          onClick={() => onSelect(suggestion)}
          className="inline-flex items-center rounded-md border px-2.5 py-0.5 font-mono text-xs cursor-pointer transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {suggestion}
        </button>
      ))}
    </div>
  </div>
)
